export default function authHeader() {
  const tokenStr = localStorage.getItem("s_u_t");

  let token = null;
  if (!tokenStr) return { Authorization: '' };
  token = JSON.parse(tokenStr);
  if (token && token.accessToken) {
    return { Authorization: 'Bearer ' + token.accessToken }; // for Spring Boot back-end
    // return { 'x-access-token': user.accessToken };       // for Node.js Express back-end
  } else {
    return { Authorization: '' }; // for Spring Boot back-end
    // return { 'x-access-token': null }; // for Node Express back-end
  }
}